// Redes/index.js
import React, { useState, useMemo } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import TableRedes from "./components/TableRedes";

const Redes = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  // Determinar si el usuario es Técnico Redes (solo lectura en creación/edición)
  const isTecnicoRedes = useMemo(() => {
    try {
      const userData = localStorage.getItem("user");
      if (!userData) return false;

      const parsed = JSON.parse(userData);

      let roleObj = null;
      let roleName = "";

      if (parsed.user?.role) {
        roleObj = parsed.user.role;
      } else if (parsed.role) {
        roleObj = parsed.role;
      } else if (parsed.more?.role) {
        roleObj = parsed.more.role;
      }

      if (roleObj) {
        if (typeof roleObj === "object" && roleObj !== null) {
          roleName = roleObj.name || "";
        } else if (typeof roleObj === "string") {
          roleName = roleObj;
        }
      }

      const roleLower = roleName.toLowerCase();
      const username = (parsed.user?.username || parsed.username || "").toLowerCase();

      // Verificar si es Técnico Redes
      return (
        roleLower.includes("tecnico redes") ||
        roleLower.includes("técnico redes") ||
        roleLower === "tecnico_redes" ||
        roleLower === "tecnico-redes" ||
        username.includes("tecnico")
      );
    } catch (error) {
      console.error("❌ Error verificando rol Técnico Redes:", error);
      return false;
    }
  }, []);

  const handleUserCreated = () => {
    setRefreshFlag((prev) => !prev);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={0} />

      <MDBox mt={2} mb={0}>
        <TableRedes refreshFlag={refreshFlag} isTecnicoRedes={isTecnicoRedes} />
      </MDBox>
    </DashboardLayout>
  );
};

export default Redes;
